import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  GetPAppAdoptionRateListRequestPayload,
  PAppAdoptionRateListResponseOK,
  PAppAdoptionRateListResponseError
} from '@repositories/api/statistics.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetPAppAdoptionRateListRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetPAppAdoptionRateListQuery<
  Data extends PAppAdoptionRateListResponseOK,
  ErrorResponse extends PAppAdoptionRateListResponseError
>({
  queryParams,
  options
}: Props<
  Data,
  ErrorResponse,
  ReturnType<typeof QUERY_KEY.STATISTICS.GET_P_APP_ADOPTION_RATE_LIST>
>) {
  return useQuery({
    queryKey: QUERY_KEY.STATISTICS.GET_P_APP_ADOPTION_RATE_LIST({ queryParams }),
    queryFn: () => {
      return ApiRepository.statistics.getPAppAdoptionRateList({ queryParams });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetPAppAdoptionRateListQuery };
